import { Seo } from "@/site/seo";
import { Heading } from "@/site/components/Section";
import LeadForm from "@/site/components/LeadForm";
import { SITE } from "@/site/content";

/**
 * Dedicated contact form -- reached from the Privacy, Terms and Security
 * pages, which need a fallback that isn't the pilot signup form. No tabs
 * (showTabs={false}): someone here for a legal/privacy question shouldn't be
 * nudged toward "Start a pilot" mid-flow.
 */
export default function ContactPage() {
  return (
    <>
      <Seo title="Contact" description="Get in touch with Postern about privacy, terms, security, or anything else." noindex={false} />
      <section className="section dotgrid">
        <div className="wrap" style={{ maxWidth: 560 }}>
          <Heading eyebrow="Contact" title="Get in touch." lede="Tell us who you are and how we can help — we'll reply within one working day." />
          {SITE.email && <p style={{ marginTop: -8, marginBottom: 28, fontSize: 14.5, color: "var(--faint)" }}>Prefer email? <a href={`mailto:${SITE.email}`} style={{ color: "var(--highlight-dark)" }}>{SITE.email}</a></p>}
          <LeadForm intent="contact" showTabs={false} source="contact_page" />
        </div>
      </section>
    </>
  );
}
